/**
 * Elastic APM RUM (Real User Monitoring) Configuration
 */
import { init as initApm } from '@elastic/apm-rum'

export const apmConfig = {
  serviceName: 'SmartInsight-Frontend',
  serverUrl: 'https://analysis.smartx.ir/',
  secretToken: 'smartsecrettoken1123',
  environment: 'development',
  
  // Optional configuration
  active: true,
  instrument: true,
  disableInstrumentations: [],
  
  // Performance monitoring
  capturePageLoad: true,
  captureInteractions: true,
  
  // Error monitoring
  captureErrors: true,
  errorThrottleLimit: 20,
  errorThrottleInterval: 30000, // 30 seconds
  
  // Transaction configuration
  transactionSampleRate: 1.0,
  centralConfig: false,
  
  // Service version (can be set from package.json or build info)
  serviceVersion: process.env.REACT_APP_VERSION || '1.0.0',
  
  // Custom configuration
  breakdownMetrics: true,
  monitorLongtasks: true,
}

// Initialize APM
let apmInstance: any = null

export const initializeApm = () => {
  if (typeof window === 'undefined' || apmInstance) {
    return apmInstance;
  }

  const isLocalhost = /(^|\/\/)(localhost|127\.0\.0\.1)(:\d+)?(?:\/|$)/.test(window.location.host);
  if (isLocalhost || process.env.REACT_APP_DEMO_MODE === 'true') {
    return null;
  }

  try {
    apmInstance = initApm(apmConfig)
    console.log('✅ Elastic APM RUM initialized successfully')
    return apmInstance
  } catch (error) {
    console.error('❌ Failed to initialize APM RUM:', error)
    return null
  }
}

export const getApmInstance = () => apmInstance

export default apmInstance